import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <small>
      <a
        href="https://github.com/mirkiy/react-weather-app"
        target="_blank "
        rel="noreferrer"
      >
        Open-source code
      </a>
      , by Mirka Zacharova
    </small>
  );
}
